import * as React from 'react';
import {
    FiMenu,
    FiSettings,
    FiCalendar,
    FiUsers,
    FiMapPin,
    FiBox,
    FiEye,
    FiThumbsUp,
    FiFileText,
    FiUser,
    FiBarChart,
    FiClock,
    FiDroplet,
    FiGlobe
} from 'react-icons/fi';
import PropTypes from 'prop-types';

// Styles
import './styles.scss';

interface Props {
    iconName?: React.ReactNode;
}

export const SidebarNavigationItemIcon: React.FC<Props> = (props) => {
    const { iconName } = props;

    let Icon;

    const iconProps = {
        size: '24',
        style: { height: 45 }
    };

    switch (iconName) {
        case 'FiMenu':
            Icon = <FiMenu {...iconProps} />;
            break;
        case 'FiSettings':
            Icon = <FiSettings {...iconProps} />;
            break;
        case 'FiCalendar':
            Icon = <FiCalendar {...iconProps} />;
            break;
        case 'FiUsers':
            Icon = <FiUsers {...iconProps} />;
            break;
        case 'FiMapPin':
            Icon = <FiMapPin {...iconProps} />;
            break;
        case 'FiBox':
            Icon = <FiBox {...iconProps} />;
            break;
        case 'FiEye':
            Icon = <FiEye {...iconProps} />;
            break;
        case 'FiThumbsUp':
            Icon = <FiThumbsUp {...iconProps} />;
            break;
        case 'FiFileText':
            Icon = <FiFileText {...iconProps} />;
            break;
        case 'FiUser':
            Icon = <FiUser {...iconProps} />;
            break;
        case 'FiBarChart':
            Icon = <FiBarChart {...iconProps} />;
            break;
        case 'FiClock':
            Icon = <FiClock {...iconProps} />;
            break;
        case 'FiDroplet':
            Icon = <FiDroplet {...iconProps} />;
            break;
        case 'FiGlobe':
            Icon = <FiGlobe {...iconProps} />;
            break;
        default:
            Icon = null;
            break;
    }

    return <div className="sidebar-navigation-item-icon">{Icon}</div>;
};

SidebarNavigationItemIcon.defaultProps = {
    iconName: undefined
};

SidebarNavigationItemIcon.propTypes = {
    iconName: PropTypes.string
};

export default SidebarNavigationItemIcon;
